import { v4 as uuidv4 } from "uuid";
import { FieldProps, GroupProps } from "../../utils/functionsInterfaces";
import { displayError, displayInfo } from "../../utils/messageToast";

export const handleCopyGroup = (
  groupId: string,
  groupName: string,
  form: GroupProps[],
  setForm: React.Dispatch<React.SetStateAction<GroupProps[]>>,
  uuid: string,
  setButtonSave: React.Dispatch<React.SetStateAction<boolean>>
) => {
  try {
    // Função recursiva para encontrar o grupo a ser copiado e o grupo pai
    const findGroupAndParent = (
      groups: (GroupProps | FieldProps)[],
      groupId: string,
      uuid: string
    ): { group: GroupProps | null; parent: GroupProps | null } => {
      for (const group of groups) {
        if ("children" in group) {
          if (group.uuid === uuid || group.id === groupId) {
            return { group: group as GroupProps, parent: null };
          }
          const found = findGroupAndParent(group.children ?? [], groupId, uuid);
          if (found.group) {
            if (found.parent === null) {
              found.parent = group as GroupProps;
            }
            return found;
          }
        }
      }
      return { group: null, parent: null };
    };

    const { group: groupToCopy, parent: parentGroup } = findGroupAndParent(
      form,
      groupId,
      uuid
    );
    if (!groupToCopy) {
      console.error("Group not found");
      return;
    }

    const nameWithoutNumber = groupId.replace(/\d+$/, "");

    const sameNameGroups = (parentGroup ? parentGroup.children : form).filter(
      (group: any) => {
        const otherNameWithoutNumber = group.id.replace(/\d+$/, "");
        return otherNameWithoutNumber === nameWithoutNumber;
      }
    );

    let incrementedCounter = sameNameGroups.length;

    let newGroupId = `${nameWithoutNumber}${incrementedCounter}`;

    while (
      (parentGroup ? parentGroup.children : form).some(
        (group: any) => group.id === newGroupId
      )
    ) {
      incrementedCounter++;
      newGroupId = `${nameWithoutNumber}${incrementedCounter}`;
    }

    const copiedGroup: GroupProps = {
      ...groupToCopy,
      uuid: uuidv4(),
      id: newGroupId,
      name: groupName,
      children: groupToCopy.children.map((child: FieldProps | GroupProps) => ({
        ...child,
        uuid: uuidv4(), // Ensure each field/group has a unique UUID
      })),
    };

    const groupWithMaxNumberIndex = (
      parentGroup ? parentGroup.children : form
    ).reduce((acc: number, group: GroupProps, index: number) => {
      if (group.id.includes(nameWithoutNumber)) {
        acc = index;
      }
      return acc;
    }, 0);

    const newForm = [...form];
    const targetGroup = parentGroup ? parentGroup.children : newForm;
    targetGroup.splice(groupWithMaxNumberIndex + 1, 0, copiedGroup);
    setForm(newForm);
    setButtonSave(true);
    displayInfo("Grupo duplicado!");
  } catch (error: any) {
    displayError("Erro ao duplicar grupo!");
  }
};
